"use strict";
'use es6';
/**
 * Fork of UIComponents/nav/UINavList
 * https://git.hubteam.com/HubSpot/UIComponents/blob/e8c8ab2/UIComponents/static-2.3729/js/nav/UINavList.js
 */

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireWildcard(require("react"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _classnames = _interopRequireDefault(require("classnames"));

var _navUtils = require("./utils/navUtils");

var _sizes = require("HubStyleTokens/sizes");

var _HR = _interopRequireDefault(require("UIComponents/elements/HR"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H7"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-bottom: 20px;\n\n  .nav__wrapper {\n    margin-bottom: 0;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 4px;\n\n  & .nav__wrapper {\n    .nav-item {\n      font-size: ", ";\n      padding-bottom: 8px;\n      padding-top: 8px;\n      padding-left: 24px;\n    }\n  }\n\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var Ul = _styledComponents.default.ul.withConfig({
  displayName: "NavList__Ul",
  componentId: "sc-1g3g5qd-0"
})(_templateObject(), _sizes.MICROCOPY_SIZE, function (_ref) {
  var depth = _ref.depth;
  return depth === 0 ? "margin-bottom: 0;" : "";
});

var Nav = _styledComponents.default.nav.withConfig({
  displayName: "NavList__Nav",
  componentId: "sc-1g3g5qd-1"
})(_templateObject2());

var NavList = (0, _createReactClass.default)({
  displayName: 'NavList',
  propTypes: {
    children: _propTypes.default.node,
    className: _propTypes.default.string,
    depth: _propTypes.default.number,
    value: _propTypes.default.node,
    _rootComponent: _propTypes.default.func,
    _transformChildProps: _propTypes.default.func
  },
  getDefaultProps: function getDefaultProps() {
    return {
      depth: 0,
      value: null,
      _transformChildProps: function _transformChildProps() {
        return {};
      }
    };
  },
  rerenderFromRoot: function rerenderFromRoot(children) {
    if (children == null) return null;
    var _this$props = this.props,
        depth = _this$props.depth,
        value = _this$props.value,
        _rootComponent = _this$props._rootComponent,
        _transformChildProps = _this$props._transformChildProps;
    var Root = _rootComponent || NavList;
    var props = {
      depth: depth + 1,
      value: value,
      _rootComponent: _rootComponent,
      _transformChildProps: _transformChildProps
    };
    return _react.default.createElement(Root, props, children);
  },
  render: function render() {
    var _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        className = _this$props2.className,
        depth = _this$props2.depth,
        __rootComponent = _this$props2._rootComponent,
        _transformChildProps = _this$props2._transformChildProps,
        value = _this$props2.value,
        rest = (0, _objectWithoutProperties2.default)(_this$props2, ["children", "className", "depth", "_rootComponent", "_transformChildProps", "value"]);
    var classes = (0, _classnames.default)(className, 'nav__wrapper');
    return _react.default.createElement(Nav, (0, _extends2.default)({}, rest, {
      className: classes
    }), _react.default.createElement(Ul, {
      depth: depth
    }, _react.Children.map(children, function (child) {
      if (!_react.default.isValidElement(child)) {
        return child;
      }

      var defaultOpen = child && child.props && child.props.defaultOpen;

      if (child.type === _HR.default || child.type === _H.default) {
        return child; // to prevent a console warning as a result of UINestedNav having H7 or HR as children
      }

      return (0, _react.cloneElement)(child, (0, _extends2.default)({
        active: (0, _navUtils.isChildActive)(child, value),
        defaultOpen: defaultOpen || (0, _navUtils.containsActiveChild)(child, value),
        value: undefined,
        _rootRenderer: _this.rerenderFromRoot
      }, _transformChildProps(child.props)));
    })));
  }
});
var _default = NavList;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ecosystem-marketplace-core/static-1.1225/js/components/nav/NavList.js
// module id = 709
// module chunks = 209 210 211 212